module.exports = __webpack_public_path__ + "img/logo-red@2x.ab177275.png";